import * as React from "react";

export default class RespondInvitePointComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div>
        <div className="desc">
          Join to post supporting and opposing Points and Facts. You can also
          review existing Facts.
        </div>
      </div>
    );
  }
}
